import { BpMetricsPlacement } from '@ads-ep/api-metrics';
import { PlacementMetadata } from './placement-meta-data.model';

export enum PlacementElement {
  Title = 'title',
  AddOn = 'body_add_on',
  Body = 'body',
  TitleAddOn = 'title_add_on',
  BodyAction = 'body_action'
}

export interface PlacementCSData {
  [PlacementElement.Title]?: string;
  [PlacementElement.TitleAddOn]?: string;
  [PlacementElement.Body]?: string;
  [PlacementElement.AddOn]?: string;
  [PlacementElement.BodyAction]?: string;
}

export type AvailContentStringGroup = keyof PlacementCSData;

export interface ContentStringObj {
  group: AvailContentStringGroup;
  key: string;
  value: string;
}

export class PlacementTrackingObj implements BpMetricsPlacement {
  id: string;
  placementContentId?: string;
  overlayContentId?: string;

  constructor(placementConfig: Partial<BpMetricsPlacement>) {
    this.id = placementConfig.id;
    this.placementContentId = placementConfig.placementContentId;
    this.overlayContentId = placementConfig.overlayContentId;
  }
}
